import Link from '@mui/icons-material/Link'
import { openInNewTab } from '../../../utils'

export const VisioConference = ({ record }) => {
  return (
    <span
      onClick={(e) => {
        e.preventDefault()
        if (record.visio_link) {
          openInNewTab(record.visio_link)
        }
      }}
      style={{ cursor: record.visio_link ? 'pointer' : '' }}
    >
      <Link style={{ color: record.visio_link ? '#1976d2' : '#ced4da' }} />
    </span>
  )
}
export default VisioConference
